import { getApiBaseUrl } from '@/app/runtime';
import i18n from '@/i18n';
import axios from 'axios';
import normalizeBaseDomain from './normalizeBaseDomain';

const authMethod = process.env.VUE_APP_AUTH_METHOD || 'direct';
const baseDomain =
  authMethod === 'direct'
    ? normalizeBaseDomain(process.env.VUE_APP_SCRUMBLE_API_URL)
    : normalizeBaseDomain(getApiBaseUrl());
const baseURL = authMethod === 'direct' ? `${baseDomain}/api/v1` : `${baseDomain}/api/v2/scrumble/`;

const request = axios.create({
  baseURL,
});

request.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = i18n.global.locale.value;
    return config;
  },
  (error) => Promise.reject(error)
);

export default request;
